import { createTheme } from '@mui/material';
/** canaryise header row in object table via
 * MuiDataGrid-columnHeaders
 */
export const objectCardTheme = createTheme({
    components: {
        MuiDataGrid: {
            styleOverrides: {
                columnHeaders: {
                    backgroundColor: 'orange',
                    borderBottom: 'none',
                },
            },
        },
    },
});
